import { __awaiter } from "tslib";
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ReducerType } from './types';
import { addDistance } from '@open-tender/utils';
const initialState = {
    revenueCenters: [],
    loading: 'idle',
    error: null
};
export var RevenueCentersActionType;
(function (RevenueCentersActionType) {
    RevenueCentersActionType["FetchRevenueCenters"] = "revenueCenters/fetchRevenueCenters";
    RevenueCentersActionType["FetchLocations"] = "revenueCenters/fetchLocations";
})(RevenueCentersActionType || (RevenueCentersActionType = {}));
export const fetchRevenueCenters = createAsyncThunk(RevenueCentersActionType.FetchRevenueCenters, (requestData, { getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { api } = getState().config;
        if (requestData.lat)
            requestData.lat = parseFloat(requestData.lat.toFixed(7));
        if (requestData.lng)
            requestData.lng = parseFloat(requestData.lng.toFixed(7));
        const { data } = yield api.getRevenueCenters(requestData.type, requestData.is_outpost, requestData.lat, requestData.lng, requestData.requestedAt, requestData.service_type);
        const revenueCenters = requestData.lat && requestData.lng
            ? addDistance(data, { lat: requestData.lat, lng: requestData.lng })
            : data;
        return revenueCenters;
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const fetchLocations = createAsyncThunk(RevenueCentersActionType.FetchLocations, (requestData, { getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { api } = getState().config;
        if (requestData.lat)
            requestData.lat = parseFloat(requestData.lat.toFixed(7));
        if (requestData.lng)
            requestData.lng = parseFloat(requestData.lng.toFixed(7));
        const { data } = yield api.getLocations(requestData.type, requestData.is_outpost, requestData.lat, requestData.lng, requestData.requestedAt, requestData.cart_total, requestData.address, requestData.service_type);
        const revenueCenters = requestData.lat && requestData.lng
            ? addDistance(data, { lat: requestData.lat, lng: requestData.lng })
            : data;
        return revenueCenters;
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
const revenueCentersSlice = createSlice({
    name: ReducerType.RevenueCenters,
    initialState,
    reducers: {
        resetRevenueCenters: () => initialState,
        setRevenueCenters: (state, action) => {
            state.revenueCenters = action.payload;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchRevenueCenters.fulfilled, (state, action) => {
            state.revenueCenters = action.payload;
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(fetchRevenueCenters.pending, state => {
            state.loading = 'pending';
        })
            .addCase(fetchRevenueCenters.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = 'idle';
        })
            .addCase(fetchLocations.fulfilled, (state, action) => {
            state.revenueCenters = action.payload;
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(fetchLocations.pending, state => {
            state.loading = 'pending';
        })
            .addCase(fetchLocations.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = 'idle';
        });
    }
});
export const { resetRevenueCenters, setRevenueCenters } = revenueCentersSlice.actions;
export const selectRevenueCenters = (state) => state.revenueCenters;
export const selectRevenueCenterCount = (state) => state.revenueCenters ? state.revenueCenters.revenueCenters.length : 0;
export const revenueCentersReducer = revenueCentersSlice.reducer;
